import { render, staticRenderFns } from "./RateDetailsSummary.vue?vue&type=template&id=5aa2986f&scoped=true"
import script from "./RateDetailsSummary.vue?vue&type=script&lang=js"
export * from "./RateDetailsSummary.vue?vue&type=script&lang=js"
import style0 from "./RateDetailsSummary.vue?vue&type=style&index=0&id=5aa2986f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa2986f",
  null
  
)

export default component.exports